import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { CardPagination } from './../CardPagination';
import { CardContainer } from './../CardContainer';

class GenericProjectStep extends Component {
  unlisten = null;

  constructor(props) {
    super(props);
    this.state = {
      slideIndex: this.props.slideIndex || 0,
    };

    this.toPrevSlide = this.toPrevSlide.bind(this);
    this.toNextSlide = this.toNextSlide.bind(this);
    this.toSlideIndex = this.toSlideIndex.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.unlisten = this.props.history.listen(() => {
      this.toSlideIndex(0);
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  toPrevSlide() {
    this.setState({
      ...this.state,
      slideIndex: this.state.slideIndex - 1,
    });
  }

  toNextSlide() {
    this.setState({
      ...this.state,
      slideIndex: this.state.slideIndex + 1,
    });
  }

  toSlideIndex(newIndex) {
    this.setState({
      ...this.state,
      slideIndex: newIndex,
    });
  }

  getChildren() {
    let children = this.props.children;
    if (typeof children === 'object' && children.length === undefined) {
      children = [children];
    }
    return children.map((child, index) => {
      let childProps = {
        ...child.props,
      };
      if (index < children.length - 1) {
        childProps.toNextStep = this.toNextSlide;
      }
      if (index > 0) {
        childProps.toPrevStep = this.toPrevSlide;
      }
      const newChild = {
        ...child,
        props: {
          ...childProps,
        },
      };
      const cardProps = {
        footerItems:
          this.props.footerItems && this.props.footerItems[index]
            ? this.props.footerItems[index]
            : undefined,
      };
      return (
        <CardContainer
          {...cardProps}
          currStep={index + 1}
          totalSteps={children.length}
          key={index}
        >
          {newChild}
        </CardContainer>
      );
    });
  }

  render() {
    const classes = this.props.className || '';
    return (
      <div className={classes}>
        <CardPagination slideIndex={this.state.slideIndex} centered={true}>
          {this.getChildren()}
        </CardPagination>
      </div>
    );
  }
}

GenericProjectStep.propTypes = {
  slideIndex: PropTypes.number,
  footerItems: PropTypes.array,
};

export default withRouter(GenericProjectStep);
